import { template } from '../../template';

app.VendorDetailsView = app.BaseDetailsView.extend({
  template: template($('#menu-item-array-details-template').html()),
  valueDisplayTemplate: template($('#value-display-template').html()),

  initialize() {
    app.BaseDetailsView.prototype.initialize.apply(this, arguments);

    const vendor = this.model;
    if (!vendor.isNew()) {
      const menuItems = app.menuItemList.filter((menuItem) => {
        return menuItem.get('vendorId') === vendor.id;
      });
      this._menuItemList = new app.MenuItemList(menuItems);
      this.listenTo(this._menuItemList, 'add', this._renderMenuItemList);
      this.listenTo(this._menuItemList, 'change', this._renderMenuItemList);
      this.listenTo(this._menuItemList, 'remove', this._renderMenuItemList);
    }

    if (!app.userList.hasBeenFetched()) {
      // We don't need to listen for the event since the list field view already does that
      app.userList.fetch({ reset: true });
    }
  },

  _renderMenuItemList() {
    const itemIds = this._menuItemList.map((item) => {
      return item.id;
    });

    if (this._dropdown) {
      this._dropdown.destroy();
    }
    this._dropdown = new app.Dropdown();
    const $itemPanel = this.$('.item-list-panel');
    this._dropdown.setupRows($itemPanel, itemIds, this._menuItemList, {
      onClick(item) {
        const detailsView = new app.MenuItemDetailsView({
          model: item,
        });
        app.modalManager.showModalWithView(detailsView);
      },
      canBeRemoved() {
        return false;
      },
    });

    this.$el.find('.card-footer').show();
    let summary = '';
    if (itemIds.length) {
      summary += `${itemIds.length} menu item${itemIds.length === 1 ? '' : 's'}`;
    } else {
      summary += 'No menu items in this vendor yet.';
    }
    this.$el.find('.card-footer').html(summary);
  },

  render() {
    app.BaseDetailsView.prototype.render.apply(this);

    if (this._menuItemList) {
      this.$el.append(
        this.template({
          canAddItems: false,
          canCreateItems: false,
          itemCategory: 'Menu Item',
        }),
      );
      this.$('.reco-panel').remove();

      this._renderMenuItemList();
    }

    const vendorId = this.model.id;
    const $valueDisplay = this.valueDisplayTemplate({
      label: 'Vendor ID:',
      value: vendorId,
    });

    const $displayGroup = $('<div class="field-group"></div>');
    $displayGroup.append($valueDisplay);
    this.$el.append($displayGroup);

    return this;
  },
});
